function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(247, 242, 234)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return 1.5 > (backgroundColorBrightness / colorBrightness);
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'rolled-canvas': 'url("//pureoilstudio.com/cdn/shop/files/rolled-canvas_120x.webp?v=15168193247481648901")','frameless': 'url("//pureoilstudio.com/cdn/shop/files/stretched_120x.webp?v=5440043962148796675")','stretch-black-frame': 'url("//pureoilstudio.com/cdn/shop/files/black-frame_120x.webp?v=307408730047670818")','stretch-white-frame': 'url("//pureoilstudio.com/cdn/shop/files/white-frame_120x.webp?v=7765120054216617777")','stretch-silver-frame': 'url("//pureoilstudio.com/cdn/shop/files/silver-frame_120x.webp?v=7962348166709573048")','stretch-gold-frame': 'url("//pureoilstudio.com/cdn/shop/files/gold-frame_120x.webp?v=13391867966628389715")','stretch-wood-frame': 'url("//pureoilstudio.com/cdn/shop/files/wood-frame_120x.webp?v=10896429493910607222")',};

    this.triggers = ['rolled canvas/frameless/framed','frameless/framed',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
